// extracted by mini-css-extract-plugin
export default {"textWithBorder":"ExternalLink-module__textWithBorder___fefA6","svgIconBackground":"ExternalLink-module__svgIconBackground___7OVl5"};